import * as React from 'react';

import {Illustration} from '../illustrations/illustration';

import {EmptyStateSmall} from './empty-state-small';

import styles from './nothing-found-empty-state.module.css';

type Props = {
    title?: string;
    subtitle?: React.ReactNode | string;
    icon?: React.ReactNode;
};

export function NothingFoundEmptyState(props: Props) {
    const icon = props.icon || (
        <div className={styles['icon-container']}>
            <Illustration src='magnifying-glass' width='100%' height='100%' />
        </div>
    );

    return (
        <EmptyStateSmall
            title={props.title || 'Nothing found'}
            subtitle={props.subtitle || 'Try loosening your search!'}
            icon={icon}
        />
    );
}
